import React from "react";
import { SectionTabs, type SectionTab } from "@cms/ui/components/section-tabs";

const BILLING_TABS: SectionTab[] = [
  { label: "Overview", href: "/billing", end: true },
  { label: "Plan", href: "/billing/plan", end: true },
  { label: "Invoices", href: "/billing/invoices", end: true },
];

/** The Billing section's sticky tab header; `action` renders right-aligned. */
export function BillingTabs({ action }: { action?: React.ReactNode }) {
  return <SectionTabs sticky items={BILLING_TABS} action={action} />;
}
